import { SVGProps } from 'react'
import cx from 'classnames'
import theme from '@theme'

const CalendarSVG = ({
  color = theme.icon.primary,
  className,
  ...props
}: SVGProps<any>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={cx('tb-icon-calendar', className)}
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.927 7.45864H5.07145C4.80189 7.45864 4.58375 7.67737 4.58375 7.94765C4.58375 8.21794 4.80189 8.43666 5.07145 8.43666H10.9285C11.1981 8.43666 11.4162 8.21794 11.4162 7.94765C11.4147 7.67737 11.1966 7.45864 10.927 7.45864ZM10.927 10.1068H5.07145C4.80189 10.1068 4.58375 10.3255 4.58375 10.5958C4.58375 10.8661 4.80189 11.0848 5.07145 11.0848H10.9285C11.1981 11.0848 11.4162 10.8661 11.4162 10.5958C11.4147 10.3255 11.1966 10.1068 10.927 10.1068ZM13.8766 2.87477H12.0753V2.48887C12.0753 2.21859 11.8572 1.99986 11.5876 1.99986C11.3181 1.99986 11.0999 2.21859 11.0999 2.48887V2.87477H4.8985V2.48887C4.8985 2.21859 4.68036 1.99986 4.4108 1.99986C4.14124 1.99986 3.92309 2.21859 3.92309 2.48887V2.87477H2.12187C1.50173 2.87477 1 3.37784 1 3.99964V12.8737C1 13.4955 1.50173 13.9985 2.12187 13.9985H13.8781C14.4983 13.9985 15 13.4955 15 12.8737V3.99964C14.9984 3.3794 14.4967 2.87477 13.8766 2.87477ZM2.12187 3.99965H3.92465V4.25275C3.92465 4.52303 4.14279 4.74176 4.41235 4.74176C4.68191 4.74176 4.90006 4.52303 4.90006 4.25275V3.99965H11.1015V4.25275C11.1015 4.52303 11.3196 4.74176 11.5892 4.74176C11.8588 4.74176 12.0769 4.52303 12.0769 4.25275V3.99965H13.8797V5.5323H2.12187V3.99965ZM13.8766 12.8737H2.12187V6.50562H13.8781V12.8737C13.8766 12.8737 13.8766 12.8737 13.8766 12.8737Z"
      transform="translate(-568 -329) translate(216 180) translate(0 24) translate(0 37) translate(0 76) translate(352 12)"
      fill={color}
    />
  </svg>
)

export default CalendarSVG
